import { Tooltip } from '@toggle/design-system';
import React from 'react';

import * as S from './AxisUnit.styles';

export interface AxisUnitProps {
  label: string;
  tooltipLabel: string;
  isMixed: boolean;
  gutterWidth: number;
  top: number;
  offset?: number;
}

export const AxisUnit = ({
  top,
  label,
  tooltipLabel,
  isMixed,
  offset,
  gutterWidth,
}: AxisUnitProps) => {
  return (
    <S.Container
      $offset={offset}
      $width={gutterWidth}
      $top={top}
      data-testid="axis-unit-root"
    >
      <Tooltip
        label={tooltipLabel}
        isTouchDevice={false}
        closeLabel=""
        disabled={!isMixed}
        inPortal
      >
        <S.StyledBadge
          label={<S.Label data-testid="unit-badge">{label}</S.Label>}
          color="neutral"
          badgeStyle="outline"
          size="small"
        />
      </Tooltip>
    </S.Container>
  );
};
